module.exports = __webpack_public_path__ + "static/img/Curtis.0a4ee2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Curtis.jpg
// module id = RG5a
// module chunks = 0